import { render, staticRenderFns } from "./LeadsPivotPage.vue?vue&type=template&id=14a6ad8b&scoped=true&"
import script from "./LeadsPivotPage.vue?vue&type=script&lang=ts&"
export * from "./LeadsPivotPage.vue?vue&type=script&lang=ts&"
import style0 from "./LeadsPivotPage.vue?vue&type=style&index=0&id=14a6ad8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a6ad8b",
  null
  
)

export default component.exports